type AddressInfo = {
    zipCode: string;
    streetName: string;
    houseNumber: string;
    postalCodeName: string;
    supCityName: string;
    floor: string;
    door: string;
};

type AddressFieldEventStatus = 'valid' | 'invalid' | 'custom';

type AddressFieldEventName = 'select' | 'blur' | 'reset';

type AddressFieldEventPayload = {
    address: string;
    addressInfo: AddressInfo;
    status: AddressFieldEventStatus;
    event: AddressFieldEventName;
    kvhx: string | undefined;
    kvhxUrl: string;
};

type AddressFieldEvent = (payload: AddressFieldEventPayload) => void;

type AddressFieldStatus = AddressFieldEventStatus | undefined;

const EMPTY_ADDRESS_INFO: AddressInfo = {
    zipCode: '',
    streetName: '',
    houseNumber: '',
    postalCodeName: '',
    supCityName: '',
    floor: '',
    door: '',
};

export type {
    AddressFieldEvent,
    AddressFieldEventName,
    AddressFieldEventPayload,
    AddressFieldEventStatus,
    AddressFieldEventPayload as FieldEventDataProps,
    AddressFieldEvent as IFieldEventFunction,
    AddressFieldStatus,
    AddressInfo,
};
export { EMPTY_ADDRESS_INFO };
